import { render, staticRenderFns } from "./salaryadvances.vue?vue&type=template&id=964fc0f0&scoped=true"
import script from "./salaryadvances.vue?vue&type=script&lang=js"
export * from "./salaryadvances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964fc0f0",
  null
  
)

export default component.exports